import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Switch,
  Typography,
  Divider,
  IconButton
} from '@mui/material';
import {
  Settings as SettingsIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import { useProjectMenu } from '../../contexts/ProjectMenuContext';

const ProjectMenuSettings = () => {
  const { menuSettings, updateMenuSettings, loading } = useProjectMenu();
  const [open, setOpen] = useState(false);
  const [localSettings, setLocalSettings] = useState(menuSettings);

  const handleOpen = () => {
    setLocalSettings(menuSettings);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async () => {
    try {
      await updateMenuSettings(localSettings);
      setOpen(false);
    } catch (error) {
      console.error('Failed to update settings:', error);
    }
  };

  const handleToggle = (option) => (event) => {
    setLocalSettings(prev => ({
      ...prev,
      [option]: event.target.checked
    }));
  };

  return (
    <>
      <Button
        startIcon={<SettingsIcon />}
        onClick={handleOpen}
        variant="outlined"
        size="small"
        sx={{ minWidth: 'auto', textTransform: 'none !important' }}
      >
        Menu settings
      </Button>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Project menu settings</Typography>
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Configure which actions are visible in the project card menus.
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={localSettings.showEditOption}
                  onChange={handleToggle('showEditOption')}
                  color="primary"
                />
              }
              label={
                <Box>
                  <Typography variant="body1">Show edit option</Typography>
                  <Typography variant="caption" color="text.secondary">
                    Allow users to edit project details
                  </Typography>
                </Box>
              }
            />

            <Divider />

            <FormControlLabel
              control={
                <Switch
                  checked={localSettings.showCloneOption}
                  onChange={handleToggle('showCloneOption')}
                  color="primary"
                />
              }
              label={
                <Box>
                  <Typography variant="body1">Show clone option</Typography>
                  <Typography variant="caption" color="text.secondary">
                    Allow users to clone projects
                  </Typography>
                </Box>
              }
            />

            <Divider />

            <FormControlLabel
              control={
                <Switch
                  checked={localSettings.showArchiveOption}
                  onChange={handleToggle('showArchiveOption')}
                  color="primary"
                />
              }
              label={
                <Box>
                  <Typography variant="body1">Show archive option</Typography>
                  <Typography variant="caption" color="text.secondary">
                    Allow users to archive/unarchive projects
                  </Typography>
                </Box>
              }
            />
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={handleSave}
            variant="contained"
            disabled={loading}
            sx={{
              textTransform: 'none !important'
            }}
          >
            Save settings
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProjectMenuSettings;